export const noResultMessageContainerStyles = {
	height: 'calc(100% - 5rem)',
};

export const noResultsFoundMessageStyles = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	gap: '1.5rem',
	padding: '2.5rem',
};
